import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { api } from '~/lib/api';

// Founder Mode gate. All /founder/* routes are hidden in Human Mode.
export const Route = createFileRoute('/_authed/founder')({
  beforeLoad: async () => {
    const me = await api.me().catch(() => ({ user: null }));
    if (me.user?.personaMode !== 'founder') throw redirect({ to: '/today' });
    return {};
  },
  component: () => <Outlet />,
});
